import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `reference_guides` anchor component.
 * Keep in sync with ReferenceGuidesProps in src/ui/uiConfig/anchorComponents/ReferenceGuides/ReferenceGuides.types.ts
 */
export const referenceGuidesPropDocs: ComponentDocMap = {
  guides: {
    description: 'Guide cards shown in a grid.',
    type: 'ReferenceGuide[]',
    example: '[{ title: "__Operator manual", content: "How to run startup", url: "https://..." }]',
  },
  'guides[].title': { description: 'Guide title.', type: 'string' },
  'guides[].content': { description: 'Guide short description.', type: 'string' },
  'guides[].url': { description: 'External URL opened on click.', type: 'string' },
}
